<template>
    <div v-if="object" class="order-grid">
        <div class="order-grid--col">
            <div class="delivery-data">
                <div class="delivery-data--row">
                    <div class="form">
                        <div class="form--box box-span-2">
                            <div class="form-label" :class="{'form-label-error' : object.errors && object.errors.email}">
                                <h4 class="required">
                                    {{ !object.cart.email_is_filled ? 'Začnite vašim E-mailom' : 'E-mail' }}
                                </h4>

                                <input class="form-input" type="email" v-model="object.cart.email" placeholder="" :disabled="logged_user_id !== null">

                                <div v-if="object.errors && object.errors.email" class="form-error">
                                    {{ object.errors.email[0] }}
                                </div>

                                <div v-if="object.isUserRegisteredInCFT && !object.cart.delivery_address_id && !logged_user_id" class="notification notification-alert">
                                    <span class="cta-login">Prihláste sa</span> a urýchlite vypĺňanie údajov
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="object.cart.email_is_filled" class="delivery-data--row">
                    <CartAddressForm title="Dodacie údaje" type="delivery_address" :data="object.cart.delivery_address" :errors="object.errors" @update="object.cart.delivery_address = $event" />
    
                    <CartAddressForm v-if="!object.cart.is_same_billing_address" title="Fakturačné údaje" type="billing_address" :data="object.cart.billing_address" :errors="object.errors" @update="object.cart.billing_address = $event" />
          
                    <div class="form">
                        <div class="form--box box-flex box-span-2">
                            <span class="btn btn-text-action-black" @click="object.cart.add_note = !object.cart.add_note">
                                {{ !object.cart.add_note ? 'Pridať poznámku' : 'Odobrať poznámku' }}
                            </span>
                        </div>

                        <div v-if="object.cart.add_note" class="form--box box-span-2">
                            <label class="form-label" for="company">
                                <h4>Poznámka</h4>
                                <textarea class="form-input" rows="4" v-model="object.cart.note" placeholder=""></textarea>
                            </label>
                        </div>

                        <div class="form--box box-span-2">
                            <label class="form-label form-label-checkbox">
                                <input type="checkbox" class="checkbox" v-model="object.cart.is_same_billing_address">
                                <p class="font-medium">Dodacie údaje sú rovnaké ako fakturačné údaje</p>
                            </label>

                            <label class="form-label form-label-checkbox" :class="{'form-label-error' : object.errors && object.errors.business_terms_approval}">
                                <input type="checkbox" class="checkbox" v-model="object.cart.business_terms_approval">
                                <p class="font-medium">Súhlasím s obchodnými podmienkami a spracovaním osobných údajov *</p>
                            </label>

                            <label class="form-label form-label-checkbox">
                                <input type="checkbox" class="checkbox" v-model="object.cart.newsletter_approval">
                                <p class="font-medium">Súhlasím so zasielaním noviniek z Vydavateľstva Postoj</p>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="order-actions">
                <div class="order-actions--col">
                    <a :href="backUrl" class="btn btn-text-action-blue btn-text-small btn-icon-left icon-prev">Späť</a>
                </div>

                <div class="order-actions--col col-center">
                    <span class="btn btn-action-red btn-padding-big" @click="nextStep()">Pokračovať</span>
                </div>
            </div>
        </div>

        <div class="order-grid--col">
            <CartSummary :cart="object.cart" @update="loadCart()" />

            <div class="order-actions">
                <div class="order-actions--col">
                    <a :href="backUrl" class="btn btn-text-action-blue btn-text-small btn-icon-left icon-prev">Späť</a>
                </div>

                <div class="order-actions--col col-center">
                    <span class="btn btn-action-red btn-padding-big" @click="nextStep()">Pokračovať</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CartAddressForm from './delivery/CartAddressForm'
    import CartSummary from './summary/CartSummary'
    
    export default {
        components: {
            CartAddressForm,
            CartSummary
        },
        props: {
            logged_user_id: {
                type: Number
            },
            backUrl: {
                type: String
            }
        },
        data() {
            return {
                object: null
            }
        },
        created() {
            this.loadCart()
        },
        methods: {
            nextStep() {
                if ( !this.object.cart.email_is_filled ) return this.startWithEmail()

                return this.continueOnPayment()
            },
            loadCart() {
                axios.post('/api/shop/cart/delivery', {user_id: this.logged_user_id})
                .then( response => {

                    this.object = response.data.object

                    if ( response.data.object.user && response.data.object.user.delivery_address ) {

                        this.object.cart.delivery_address = response.data.object.user.delivery_address
                        
                    }
    
                }).catch( errors => { console.log( errors.response.data.errors ) })
            },
            startWithEmail() {
                axios.post('/api/shop/cart/delivery/start-with-email', this.object.cart)
                .then( response => {

                    this.object.isUserRegisteredInCFT = response.data.object.isUserRegisteredInCFT
                    this.object.cart = response.data.object.cart
    
                }).catch( errors => { this.object.errors = errors.response.data.errors })
            },
            continueOnPayment() {
                axios.post('/api/shop/cart/delivery/continue', this.object.cart)
                .then( response => {

                    this.object.errors = null
                    window.location.href = response.data.object.route
    
                }).catch( errors => { this.object.errors = errors.response.data.errors })
            }
        },
    }
</script>